import CryptoJS from 'crypto-js';

// Development mode uses a simple key for testing
const DEV_KEY = 'dev-key';

// Production mode uses environment variables
const BACKEND_PUBLIC_KEY = process.env.REACT_APP_NEXT_PUBLIC_BACKEND_PUBLIC_KEY || DEV_KEY;
const FRONTEND_PUBLIC_KEY = process.env.REACT_APP_NEXT_PUBLIC_FRONTEND_PUBLIC_KEY || DEV_KEY;
const isProduction = process.env.REACT_APP_NODE_ENV === 'production';

/**
 * Encrypts requests to the backend
 * In production: Uses the backend's public key
 * In development: Uses a simple key for testing
 */

// The object you want to encrypt
const data = { mac: "62:6d:c9:e4:66:5a" };

// function encryptResponse(data) {
//     const encrypted = CryptoJS.AES.encrypt(
//         JSON.stringify(data),
//         BACKEND_ENCRYPTION_KEY
//     ).toString();
//     return encrypted;
// }

export const encryptResponseSignup = (data) => {
    const encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(data),
        BACKEND_PUBLIC_KEY
    ).toString();

    // Convert to base64url (replace / with _, + with -, remove =)
    return encrypted.replace(/\//g, '_').replace(/\+/g, '-').replace(/=+$/, '');
}

function base64urlToBase64(str) {
    // Replace _ with / and - with +
    let base64 = str.replace(/_/g, '/').replace(/-/g, '+');
    // Pad with = to make length a multiple of 4
    while (base64.length % 4) {
        base64 += '=';
    }
    return base64;
}

// Function to decrypt (same as decryptRequest function)
export const mainfunction = (encryptedData) => {
    const isProduction = process.env.NODE_ENV === 'production';

    if (!isProduction) {
        return typeof encryptedData === 'string' ? JSON.parse(encryptedData) : encryptedData;
    }

    const encryptedBase64 = base64urlToBase64(encryptedData);


    try {
        const decrypted = CryptoJS.AES.decrypt(encryptedBase64, FRONTEND_PUBLIC_KEY);
        return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));

    } catch (error) {
        throw new Error('Invalid encrypted data');
    }
}

// Try to decrypt

export const decryptRequestSignup = (encryptedData) => {
    try {
        console.log('\nAttempting to decrypt...');
        const decrypted = mainfunction(encryptedData);
        console.log('✅ Decryption successful!');
        console.log('Decrypted data:', decrypted);
    } catch (error) {
        console.log('❌ Decryption failed:', error.message);

        // Try with different keys
        console.log('\nTrying with BACKEND_ENCRYPTION_KEY...');
        try {
            const encryptedBase64 = base64urlToBase64(encryptedData);
            const decrypted = CryptoJS.AES.decrypt(encryptedBase64, BACKEND_PUBLIC_KEY);
            return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
            // console.log('✅ Decryption successful with BACKEND_ENCRYPTION_KEY!');
            // console.log('Decrypted data:', result);
        } catch (error2) {
            console.log('❌ Also failed with BACKEND_ENCRYPTION_KEY:', error2.message);
        }
    }

}


